import { comum } from '../styles/Themes/light';

export const toastDefs = {
    duration: 3000,
    className: 'toasted',
    style: {
        background: 'var(--cffffff)',
        color: 'var(--toast-ink)',
        border: '0.5px solid ' + comum.colors.interfaceSuccess,
        padding: '16px',
        maxWidth: '500px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordBreak: 'break-word',
    } as any,
    iconTheme: {
        primary: comum.colors.interfaceSuccess,
        secondary: 'var(--cffffff)',
    },
};

export const toastDefsError = {
    duration: 3000,
    className: 'toasted',
    style: {
        background: 'var(--cffffff)',
        color: 'var(--toast-ink)',
        border: '0.5px solid ' + comum.colors.primaryRed400,
        padding: '16px',
        maxWidth: '500px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordBreak: 'break-word',
    } as any,
    iconTheme: {
        primary: comum.colors.primaryRed400,
        secondary: 'var(--cffffff)',
    },
};
